<template>
  <div>
       <v-stepper alt-labels class="ma-5">
      <v-stepper-header>
        <v-stepper-step step="1">Enquiry</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="2">Application</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="3"  >Upload Documents</v-stepper-step>
          <v-divider></v-divider>

        <v-stepper-step step="4">Evaluation</v-stepper-step>
          <v-divider></v-divider>

        <v-stepper-step step="5">Confirmation</v-stepper-step>
      </v-stepper-header>
    </v-stepper>


    <v-stepper class="ma-5" v-model="currentElement" :vertical="vertical">
      <v-row class="ma-5">
        <h3 class="">Admission Progress: APP20201229</h3>
       
      </v-row>
      <template v-if="vertical">
        <template v-for="item in items">
          <v-stepper-step
            :key="`${item.id}-step`"
            :complete="currentElement > item.id"
            :step="item.id"
            :editable="editable"
          >
            <h4>{{ item.tab }}</h4>
          </v-stepper-step>

          <v-stepper-content :key="`${item.id}-content`" :step="item.id">
            <v-card elevation="0">
              <component v-bind:is="item.content"></component>
            </v-card>

           
            <v-btn color="primary" class="ma-2" @click="nextStep(item.id)">
             Save Details
            </v-btn>
          </v-stepper-content>
        </template>
      </template>
    </v-stepper>
  </div>
</template>

<script>
import EnquiryStepperContent from "@components/onlineportal/EnquiryStepperContent";
import ApplicationStepperContent from "@components/onlineportal/ApplicationStepperContent";
import UploadedDocumentsStepperContent from "@components/onlineportal/UploadedDocumentsStepperContent";
import EvaluationStepperContent from "@components/onlineportal/EvaluationStepperContent";
import ConfirmationStepperContent from "@components/onlineportal/ConfirmationStepperContent";

export default {
  components: {
    EnquiryStepperContent: EnquiryStepperContent,
    ApplicationStepperContent: ApplicationStepperContent,
    UploadedDocumentsStepperContent: UploadedDocumentsStepperContent,
    EvaluationStepperContent: EvaluationStepperContent,
    ConfirmationStepperContent: ConfirmationStepperContent
  },
  data() {
    return {
      currentElement: 1,
      steps: 5,
      vertical: true,
      editable: true,
      items: [
        {
          id: 1,
          tab: "Enquiry",
          content: EnquiryStepperContent
        },
        {
          id: 2,
          tab: "Application",
          content: ApplicationStepperContent
        },
        {
          id: 3,
          tab: "Uploaded Documents",
          content: UploadedDocumentsStepperContent
        },
        {
          id: 4,
          tab: "Evaluation",
          content: EvaluationStepperContent
        },
        {
          id: 5,
          tab: "Confirmation",
          content: ConfirmationStepperContent
        }
      ],
      stepHeaders: [
        "Enquiry",
        "Application",
        "Uploaded Documents",
        "Evaluation",
        "Confirmation"
      ],
      stepContent: [
        "EnquiryStepperContent",
        "ApplicationStepperContent",
        "UploadedDocumentsStepperContent",
        "EvaluationStepperContent",
        "ConfirmationStepperContent"
      ]
    };
  },

  watch: {
    steps(val) {
      if (this.currentElement > val) {
        this.currentElement = val;
      }
    },
    vertical() {
      this.currentElement = 2;
      requestAnimationFrame(() => (this.currentElement = 1)); // Workarounds
    }
  },

  methods: {
    onInput(val) {
      this.steps = parseInt(val);
    },
    nextStep(n) {
      if (n === this.steps) {
        this.currentElement = 1;
      } else {
        this.currentElement = n + 1;
      }
    },
    findNextItemTabName(item) {
      return this.items[item.id % 5].tab;
    }
  }
};
</script>